import { Box, Button, Collapse } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PaymentMethodListTemplate from '../paymentMethodListTemplate';
import StripePaymentMethodList from '../stripePayMethodListTemplate';
import { stripePaymentTypes } from '../paymentMethodStripe/paymentTypes.constant';
import LocaleKeys from '../../../locales/keys';
import { useTranslation } from 'react-i18next';
import { isStripeWallet } from '../../helpers/paymentMethodStripeHelpers';
import { stripeWalletBrandImageUrls } from '../../../utils/common';
import PaymentMethodButtonAction from '../paymentMethodButtonAction';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.custom.darkRed,
    color: '#fff',
    borderRadius: '5px',
    fontWeight: 500,
    letterSpacing: 0.5,
    lineHeight: 1,
    padding: '12px 15px',
  },
  selectButton: {
    '&:hover': {
      boxShadow: `0 0 0 2px ${theme.palette.primary.dark} inset`,
      color: theme.palette.custom.black,
    },
  },
  defaultPaymentCardLabel: {
    fontFamily: 'TitilliumWeb-Regular',
    fontSize: '17px',
    letterSpacing: '.2px',
    WebkitFontSmoothing: 'auto',
  },
  nameOnCardLabel: {
    fontFamily: 'Formula1-Bold',
    fontWeight: 700,
    fontSize: '18px',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  paymentMethodListItemChangeButtonClicked: {
    paddingLeft: '0 !important',
  },
  paymentFontWeight: {
    [theme.breakpoints.between('xs', 'md')]: {
      padding: 0,
      margin: 0,
    },
  },
  imageContainer: {
    lineHeight: 0,
    paddingRight: '15px',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  expirationYear: {
    fontWeight: 700,
    paddingLeft: '15px',
  },
}));

const PaymentMethodList = ({
  classes,
  cardTypeIcon,
  isChangeClicked,
  handleSelectClick,
  handleEditClick,
  paymentMethodNode,
  paymentMethodIndex,
  defaultPaymentCardLabel,
  editCardDetailsLabel,
  selectButtonLabel,
  isPaymentTemplate,
  isStripeAccount,
  stripePaymentMethodType,
  isHideSelect,
  isPaymentReady,
}) => {
  const paymentMethodListClasses = useStyles();
  const { t } = useTranslation();
  const paymentMethodListDisplay = isPaymentTemplate
    ? 'flex'
    : isHideSelect
    ? 'flex'
    : '';
  const paymentMethodListMarginLeft = isPaymentTemplate
    ? '30px'
    : isHideSelect
    ? '30px'
    : '';

  const walletStyle =
    isStripeAccount && isStripeWallet(stripePaymentMethodType)
      ? { borderRadius: '15px', border: '1px solid #d0d0d2' }
      : {};
  return (
    <Box
      key={paymentMethodIndex}
      className="panel-body"
      style={{
        padding: '0 5px 0 0',
        marginLeft: paymentMethodListMarginLeft,
      }}
    >
      {paymentMethodNode?.Default &&
      !isPaymentTemplate &&
      !isStripeWallet(stripePaymentMethodType) ? (
        <Box
          pb={2}
          className={paymentMethodListClasses.defaultPaymentCardLabel}
        >
          {defaultPaymentCardLabel}
        </Box>
      ) : null}
      {isStripeAccount &&
      stripePaymentMethodType !== stripePaymentTypes.CARD &&
      isStripeWallet(stripePaymentMethodType) ? (
        <Box display="flex" justifyContent={'space-between'}>
          <Box
            pb={2}
            className={paymentMethodListClasses.defaultPaymentCardLabel}
          >
            {t(
              LocaleKeys.subscriptionInfo.subscriptions.preferredPaymentMethod,
            )}
          </Box>
          <PaymentMethodButtonAction
            classes={classes}
            isPaymentTemplate={isPaymentTemplate}
            isChangeClicked={isChangeClicked}
            paymentMethodNode={paymentMethodNode}
            handleEditClick={handleEditClick}
            isPaymentReady={isPaymentReady}
            editCardDetailsLabel={t(LocaleKeys.accountInfo.edit)}
            isWallet={true}
          />
        </Box>
      ) : null}
      <Box
        style={{
          display: paymentMethodListDisplay,
          ...walletStyle,
        }}
      >
        {isStripeAccount ? (
          stripePaymentMethodType === stripePaymentTypes.CARD ? (
            <PaymentMethodListTemplate
              classes={classes}
              cardTypeIcon={cardTypeIcon}
              isChangeClicked={isChangeClicked}
              paymentMethodNode={paymentMethodNode}
              isStripeAccount={isStripeAccount}
            />
          ) : (
            <StripePaymentMethodList
              classes={classes}
              cardTypeIcon={`${stripeWalletBrandImageUrls(
                stripePaymentMethodType,
              )}`}
              stripePaymentMethodType={stripePaymentMethodType}
            />
          )
        ) : (
          <PaymentMethodListTemplate
            classes={classes}
            cardTypeIcon={cardTypeIcon}
            isChangeClicked={isChangeClicked}
            paymentMethodNode={paymentMethodNode}
          />
        )}
        {!isStripeWallet(stripePaymentMethodType) && (
          <PaymentMethodButtonAction
            classes={classes}
            isPaymentTemplate={isPaymentTemplate}
            isChangeClicked={isChangeClicked}
            paymentMethodNode={paymentMethodNode}
            handleEditClick={handleEditClick}
            isPaymentReady={isPaymentReady}
            editCardDetailsLabel={editCardDetailsLabel}
          />
        )}
      </Box>

      <Collapse in={isChangeClicked} timeout={0}>
        <Box className={paymentMethodListClasses.selectButtonContainer}>
          {isChangeClicked ? (
            <Button
              className={`${paymentMethodListClasses.button} ${paymentMethodListClasses.selectButton}`}
              disableElevation
              disableRipple
              data-testid="payment-method-list-change"
              onClick={() => {
                handleSelectClick(paymentMethodNode);
              }}
            >
              {selectButtonLabel}
            </Button>
          ) : null}
        </Box>
      </Collapse>
    </Box>
  );
};

export default PaymentMethodList;
